import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { IOrder } from '../../../../interfaces/order';
import { actions as orderActions } from '../../../../store/ducks/orders.duck';

export const getInitialValuesOrderPage = (order: IOrder) => {
  const subOrder = order?.orders?.[0];
  const mainOrder = order.main_order;
  const values: any = {
    uuid: order.uuid,
    fio: order.main_order ? order.main_order.fio || '' : order.fio || '',
    city: order.city || '',
    region: order.region || '',
    street: order.street || '',
    home: order.home || '',
    flat: order.flat || '',
    entrance: order.entrance || '',
    building: order.building || '',
    phone: order.main_order ? order.main_order.phone || '' : order.phone || '',
    comment: order.comment || '',
    status: order.status || 'payed',
    email: order.email || '',
    payment_status: order.payment_status || 'not_paid',
    deliveryType: order.delivery_type || '-',
    receivedAtString: order.received_at,
    items: [],
    timetable: order.delivery_point?.timetable || '',
    description: order.delivery_point?.description || '',
    code: order.delivery_point?.code || '',
    addressCDEKCity: order.point?.city_name || '',
    // pointCode: order.point?.cdek_code || '',
    // address: order.city?.length > 0 ? `${order.city}, ${order.address}` : order.address,
    delivery_date: order.delivery_date,
    delivery_date_string: order.delivery_date,
    delivery_type: order.delivery_type || '',
    store: subOrder?.store || order.store || undefined,
    locationDelivery: {
      address: order?.address || '',
      lng: 0,
      lat: 0,
      city: order?.city || mainOrder?.city,
      country: '',
      house: '',
      province: '',
      street: '',
      working_times: undefined,
      locality: '',
    },
    location: {
      id: undefined,
      address: order?.point?.address || '',
      lng: order?.point?.lng || 0,
      lat: order?.point?.lat || 0,
      city: order?.point?.city_name || '',
      code: order?.point?.cdek_code || '',
      country: '',
      house: '',
      province: '',
      street: '',
      working_times: undefined,
    },
  };
  if (order.main_order) {
    order.items.forEach(item => {
      values.items.push({ ...item, product_id: item?.product.id! });
    });
  } else {
    order.orders &&
      order.orders.forEach(item => {
        item.items.map(e => values.items.push({ ...e, product_id: e?.product.id! }));
      });
  }
  return values;
};

export const useFormikOrderPage = ({ order, id }: { order?: IOrder; id: string }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: order ? getInitialValuesOrderPage(order) : {},
    validationSchema: Yup.object().shape({
      phone: Yup.string()
        .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' }))
        .nullable(),
      fio: Yup.string()
        .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' }))
        .nullable(),
    }),
    onSubmit: submitValues => {
      const items = order?.items.map(item => {
        return {
          ...item,
          product_id: item.product.id!,
        };
      }) || [];
      dispatch(
        orderActions.editRequest({
          id: +id,
          data: {
            // ...submitValues,
            // storeId: order?.company ? submitValues.store?.id : undefined,
            // city: undefined,
            items,
            fio: submitValues.fio,
            status: order?.status || 'payed',
            email: submitValues.email,
            phone: submitValues.phone,
            payment_status: submitValues.payment_status,
          },
        })
      );
      const subOrder = order?.orders?.[0];
      if (subOrder && subOrder.company) {
        const items = subOrder.items.map(item => {
          return {
            ...item,
            product_id: item.product.id!,
          };
        });
        dispatch(
          orderActions.editRequest({
            id: subOrder.id,
            data: {
              status: subOrder.status,
              items,
              // storeId: subOrder.company ? submitValues.store?.id : undefined,
            },
          })
        );
      }
    },
  });

  return formik;
};
